module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei3.svg";